import { StoryblokImage } from '@cinch-nx/data-storyblok'
import { StoryblokRenderer } from '@cinch-nx/landing-ui-shared/lib/storyblok-renderer/storyblok-renderer'
import Wrapper from '@cinch-nx/shared-ui/lib/wrapper/wrapper'
import Image from 'next/image'

import { PartnershipsImageCarousel } from '../components'
import { storyblokComponents } from '../data/storyblok-renderer-map'
import styles from './partnerships.module.css'
import { PartnershipsStoryContent } from './types/partnerships-page'

export interface PartnershipsProps {
  content: PartnershipsStoryContent
}

const Partnerships: React.FC<PartnershipsProps> = ({ content }) => {
  if (!content) return null

  const image = content.Image

  return (
    <article>
      <Wrapper isSlim>
        <StoryblokRenderer
          block={content.Intro}
          components={storyblokComponents}
        />

        <StoryblokRenderer
          block={content.Partners}
          components={storyblokComponents}
        />
      </Wrapper>

      {content?.ImageCarousel?.some(
        (image: StoryblokImage) => image.filename,
      ) ? (
        <Wrapper isFluid>
          <PartnershipsImageCarousel images={content?.ImageCarousel} />
        </Wrapper>
      ) : null}

      <Wrapper isSlim>
        {image?.filename ? (
          <div className={styles.imageWrapper}>
            <Image
              src={image.filename}
              alt={image.alt ?? undefined}
              layout="intrinsic"
              width="801"
              height="481"
              objectFit="contain"
            />
          </div>
        ) : null}
      </Wrapper>
    </article>
  )
}

export default Partnerships
